<template>
  <div id="app"
       v-cloak>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  watch: {},
  computed: {
  },
  mounted () {
  }
}
</script>

<style>
#app {
  height: 100vh;
  overflow: hidden;
}
[v-cloak] {
  display: none;
}
</style>
